import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, CardHeader, Alert, CardBody, Row, Col, Label, Modal, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { toast } from 'react-toastify'
import MediaQuery from 'react-responsive'
import { DataTable, MainLoader } from '../../../../components'
import { layout } from '../../../../common/constants'
import { formatHelper } from '../../../../common/helpers'
import Swal from 'sweetalert2'

import { getCustomers } from '../../../../store/customer/actions'
import { getStores } from '../../../../store/store/actions'
import { getOffers } from '../../../../store/offer/actions'
import { getProducts } from '../../../../store/product/actions'
import { getServices } from '../../../../store/service/actions'
import { getQuotation, updateQuotation, resetQuotation, resetUpdateQuotation } from '../../../../store/quotation/actions'
import { selectQuotationForEdit } from '../../../../store/quotation/selector'

import * as columns from './_columns'
import { FormItem, FormQuotation } from './Forms'

import { selectStoresForSelectQuotation } from '../../../../store/store/selector'
import { selectCustomerForSelect } from '../../../../store/customer/selector'


class QuotationEdit extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedProducts: [],
            selectedServices: [],
            selectedOffers: [],
            modalOpen: false,
            itemType: '',
            counter: 0,
        }

        this.onSubmitQuotation = this.onSubmitQuotation.bind(this);
        this.onSubmitQuotationItem = this.onSubmitQuotationItem.bind(this);

        this.toggleModal = this.toggleModal.bind(this);
        this.optionsFormatterColumnProducts = this.optionsFormatterColumnProducts.bind(this);
        this.optionsFormatterColumnServices = this.optionsFormatterColumnServices.bind(this);
        this.optionsFormatterColumnOffers = this.optionsFormatterColumnOffers.bind(this);
        this.changeFormatValues = this.changeFormatValues.bind(this)
    }

    async componentDidMount() {
        //ITEMS
        await this.props.getProducts({ reset: true })
        await this.props.getServices({ reset: true })
        await this.props.getOffers({ reset: true, show_expired_flag: 0 })

        //DROPDOWNS
        await this.props.getCustomers({ reset: true })
        await this.props.getStores({ reset: true })

        await this.props.getQuotation(this.props.match.params.id)

        const { products, services, offers } = this.props.initialValues

        let previousProducts = []
        let previousServices = []
        let previousOffers = []

        if (products) {
            products.forEach(element => {
                element.oid = this.state.counter;
                this.state.counter = this.state.counter + 1;
                element.before_price = element.price;
                element.price = element.price * element.quantity;
                if (element.unit_discount) {
                    if (element.type_unit_discount == "true") {
                        element.price = element.price * (1 - element.unit_discount);
                        element.unit_discount = element.unit_discount * 100
                    } else {
                        element.price = element.price - element.unit_discount;
                    }
                }
                previousProducts.push(element)
            });

            this.setState({
                selectedProducts: previousProducts
            })
        }

        if (services) {
            services.forEach(element => {
                element.oid = this.state.counter;
                this.state.counter = this.state.counter + 1;
                element.before_price = element.price;
                element.price = element.price * element.quantity;
                if (element.unit_discount) {
                    if (element.type_unit_discount == "true") {
                        element.price = element.price * (1 - element.unit_discount);
                        element.unit_discount = element.unit_discount * 100
                    } else {
                        element.price = element.price - element.unit_discount;
                    }
                }
                previousServices.push(element)
            });

            this.setState({
                selectedServices: previousServices
            })
        }

        if (offers) {
            offers.forEach(element => {
                element.oid = this.state.counter;
                this.state.counter = this.state.counter + 1;
                element.before_price = element.total_price;
                element.price = element.total_price * element.quantity;
                if (element.unit_discount) {
                    if (element.type_unit_discount == "true") {
                        element.price = element.price * (1 - element.unit_discount);
                        element.unit_discount = element.unit_discount * 100
                    } else {
                        element.price = element.price - element.unit_discount;
                    }
                }
                previousOffers.push(element)
            });

            this.setState({
                selectedOffers: previousOffers
            })
        }
    }

    componentWillUnmount() {
        this.props.resetQuotation();
        this.props.resetUpdateQuotation();
    }

    componentDidUpdate(prevProps) {
        this.checkQuotationUpdate(prevProps)
    }

    checkQuotationUpdate(prevProps) {
        if (prevProps.updatedQuotation == null && this.props.updatedQuotation != null) {
            this.onSuccess();
        }
    }


    changeFormatValues(values) {
        values.products = formatHelper.cloneObject(this.state.selectedProducts)
        values.services = formatHelper.cloneObject(this.state.selectedServices)
        values.offers = formatHelper.cloneObject(this.state.selectedOffers)
        let customerId = values.customer
        values.customer = { id: customerId }
        if (values.discount) { values.discount = values.discount / 100 }

        if (values.products || values.services || values.offers) {
            values.offers.forEach(offer => {
                if (offer.unit_discount && offer.type_unit_discount == "true") offer.unit_discount /= 100;
                offer.total_price = offer.before_price;
            });

            values.products.forEach(product => {

                if (product.unit_discount && product.type_unit_discount == "true") product.unit_discount /= 100;
                product.price = product.before_price;
            });

            values.services.forEach(service => {
                if (service.unit_discount && service.type_unit_discount == "true") service.unit_discount /= 100;
                service.price = service.before_price;
            });
        }
        return values
    }

    onSubmitQuotation(values) {

        let sendValues = formatHelper.cloneObject(values);
        sendValues = this.changeFormatValues(sendValues)
        this.props.updateQuotation(this.props.match.params.id, sendValues);
    }

    onSubmitQuotationItem(values, activeItem) {
        //TODO:Añadir aca un identificador unico (GUID) para cada item de la tabla
        var { selectedProducts, selectedServices, selectedOffers, itemType, counter } = this.state;
        if (itemType == 'Productos') {
            var products = selectedProducts
            values.name = activeItem.name
            values.oid = counter
            counter++
            products.push(values);
            this.setState({
                selectedProducts: products,
                modalOpen: false,
                counter: counter,
            })

        } else if (itemType == 'Servicios') {
            let services = selectedServices
            values.name = activeItem.name
            values.oid = counter
            counter++
            services.push(values);
            this.setState({
                selectedServices: services,
                modalOpen: false,
                counter: counter,
            })
        } else if (itemType == 'Ofertas') {
            let offers = selectedOffers
            values.name = activeItem.name
            values.oid = counter
            counter++
            offers.push(values);
            this.setState({
                selectedOffers: offers,
                modalOpen: false,
                counter: counter,
            })
        }
    }

    toggleModal(type) {

        this.setState({
            itemType: type,
            modalOpen: !this.state.modalOpen
        })
    }

    onSuccess() {
        let toastMessage = 'Cotización Editada Satisfactoriamente.'
        toast.success(toastMessage)
        this.props.history.push('/administration/quotations')
    }

    performDeleteItem(oid, type) {
        let list = type == 'Productos' ? this.state.selectedProducts : (type == 'Servicios' ? this.state.selectedServices : this.state.selectedOffers);
        list = list.filter(function (obj) {
            return obj.oid !== oid //TODO: cambiar esto por un idTable
        })
        if (type == 'Productos') { this.setState({ selectedProducts: list }) }
        else if (type == 'Servicios') { this.setState({ selectedServices: list }) }
        else if (type == 'Ofertas') { this.setState({ selectedOffers: list }) }
    }

    //TODO: cambiar en los formatterColumn el id por idTable
    optionsFormatterColumnProducts(cell, row) {
        return (
            <UncontrolledButtonDropdown>
                <DropdownToggle size="sm" color='primary'>
                    <i className="fa fa-bars"></i>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={() => this.performDeleteItem(row.oid, 'Productos')} ><i className="fa fa-trash mr-1"></i> Eliminar</DropdownItem>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        )
    }
    optionsFormatterColumnServices(cell, row) {
        return (
            <UncontrolledButtonDropdown>
                <DropdownToggle size="sm" color='primary'>
                    <i className="fa fa-bars"></i>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={() => this.performDeleteItem(row.oid, 'Servicios')} ><i className="fa fa-trash mr-1"></i> Eliminar</DropdownItem>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        )
    }
    optionsFormatterColumnOffers(cell, row) {
        return (
            <UncontrolledButtonDropdown>
                <DropdownToggle size="sm" color='primary'>
                    <i className="fa fa-bars"></i>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={() => this.performDeleteItem(row.oid, 'Ofertas')} ><i className="fa fa-trash mr-1"></i> Eliminar</DropdownItem>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        )
    }

    renderDataTable(columns, data) {
        return (
            <DataTable
                data={data}
                keyField='id'
                columns={columns}
                loading={this.props.loading}
            />
        )
    }

    render() {
        const columnOptionProducts = {
            dataField: '',
            text: '',
            isDummyField: true,
            formatter: this.optionsFormatterColumnProducts,
            style: { width: '50px' },
            headerStyle: { width: '50px' }
        }
        const columnOptionService = {
            dataField: '',
            text: '',
            isDummyField: true,
            formatter: this.optionsFormatterColumnServices,
            style: { width: '50px' },
            headerStyle: { width: '50px' }
        }
        const columnOptionOffer = {
            dataField: '',
            text: '',
            isDummyField: true,
            formatter: this.optionsFormatterColumnOffers,
            style: { width: '50px' },
            headerStyle: { width: '50px' }
        }
        const { modalOpen, selectedProducts, selectedServices, selectedOffers, loading, itemType } = this.state
        const { error, loadingOffers, loadingProducts, loadingServices, updatedLoading, customers, customersLoading, stores, storesLoading } = this.props
        const isLoadingFetch = (loading || loadingOffers || loadingProducts || loadingServices || customersLoading || storesLoading)
        const isLoadingSubmit = (updatedLoading)
        if (isLoadingFetch) {
            return <MainLoader />
        }
        return (
            <div className="animated">
                <Card>
                    <CardHeader>
                        Editar Cotización
                    </CardHeader>


                    <CardBody>
                        {
                            error && (
                                <Alert color="danger">
                                    {error}
                                </Alert>
                            )
                        }
                        {
                            customers && stores && (
                                <FormQuotation
                                    initialValues={this.props.initialValues}
                                    customers={this.props.customers}
                                    stores={this.props.stores}

                                    selectedOffers={this.state.selectedOffers}
                                    selectedServices={this.state.selectedServices}
                                    selectedProducts={this.state.selectedProducts}

                                    onSubmitQuotation={this.onSubmitQuotation}
                                    toggleModal={this.toggleModal}
                                    modalOpen={modalOpen}
                                    itemType={itemType}
                                    isLoading={isLoadingSubmit}
                                ></FormQuotation>
                            )
                        }
                    </CardBody>

                </Card>
                {
                    < Card >
                        <CardHeader>
                            Items de Cotización
                        </CardHeader>
                        <CardBody>
                            {
                                selectedProducts.length > 0 && (
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <Label><b>Productos</b></Label>
                                                </Col>
                                            </Row>
                                            < Row >
                                                <Col>
                                                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsXS(columnOptionProducts), selectedProducts)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsSM(columnOptionProducts), selectedProducts)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                                                        {this.renderDataTable(columns.columns(columnOptionProducts), selectedProducts)}
                                                    </MediaQuery>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            }
                            {
                                selectedServices.length > 0 && (
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <Label><b>Servicios</b></Label>
                                                </Col>
                                            </Row>
                                            < Row >
                                                <Col>
                                                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsXS(columnOptionService), selectedServices)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsSM(columnOptionService), selectedServices)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                                                        {this.renderDataTable(columns.columns(columnOptionService), selectedServices)}
                                                    </MediaQuery>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            }
                            {
                                selectedOffers.length > 0 && (
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <Label><b>Ofertas</b></Label>
                                                </Col>
                                            </Row>
                                            < Row >
                                                <Col>
                                                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsXS(columnOptionOffer), selectedOffers)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsSM(columnOptionOffer), selectedOffers)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                                                        {this.renderDataTable(columns.columns(columnOptionOffer), selectedOffers)}
                                                    </MediaQuery>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            }

                        </CardBody>
                    </Card>
                }
                {<Modal isOpen={modalOpen} >
                    {<FormItem
                        products={this.props.products}
                        services={this.props.services}
                        offers={this.props.offers}

                        itemType={this.state.itemType}
                        onSubmitQuotationItem={this.onSubmitQuotationItem}
                        toggleModal={this.toggleModal}
                    />}
                </Modal>}
            </div>
        )
    }
}

function mapStateToProps(state) {

    const { error, loading } = state.quotation.quotationList

    const { productList } = state.product
    const { serviceList } = state.service
    const { offersList } = state.offer

    const { updateQuotation } = state.quotation

    return {


        initialValues: selectQuotationForEdit(state),
        error, loading,

        updatedQuotation: updateQuotation.quotation,
        updatedError: updateQuotation.error,
        updatedLoading: updateQuotation.loading,

        offers: offersList.offers,
        loadingOffers: offersList.loading,
        products: productList.products,
        loadingProducts: productList.loading,
        services: serviceList.services,
        loadingServices: serviceList.loading,

        customers: selectCustomerForSelect(state),
        customersLoading: state.customer.customerList.loading,
        stores: selectStoresForSelectQuotation(state),
        storesLoading: state.store.storeList.loading,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCustomers,
        getStores,

        getProducts,
        getServices,
        getOffers,

        getQuotation, updateQuotation,
        resetQuotation, resetUpdateQuotation,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotationEdit)



// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationEdit/QuotationEdit.js